export enum AmbassadorType {
  SELF_EMPLOYED = 'self-employed',
  NON_TAXABLE_INDIVIDUAL = 'non-taxable-individual',
  COMPANY = 'company'
}
